/* eslint-disable */
// eslint-disable-next-line react/no-unknown-property
import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { func } from "prop-types";
import FormField from "../common/form-field/formField";
import Button from "../common/button/button";
import BannerNotification from "../common/banner/bannerNotification";
import i18n from "../../../localization/i18n";
import Loader from "../common/loader/loader";
import * as rk from "../../../localization/resourceKeys";
import Logger from "../../../logger";
import { SessionContext } from "../../../context/sessionContext";
import login from "../../services/login";
import { useMyVW } from "../../../context/myVWContext";
import { useMyVWQueryParams } from "../../hooks/useMyVWQueryParams";

interface LoginFormProps {
  onLoginSuccess: (value: 'consent' | 'loginForm') => void;
}

const LoginForm = ( { onLoginSuccess }: LoginFormProps ) => {
  const {
    register,
    errors,
    handleSubmit,
    clearErrors,
    setError,
    setValue,
    getValues,
  } = useForm({});
  const { sessionDetails } = useContext(SessionContext);
  const [submitPending, setSubmitPending] = useState(false);
  const [badCount, setBadCount] = useState();
  const [accountLocked, setAccountLocked] = useState(false);
  const [noEmailAdressError, setNoEmailAdressError] = useState(false);
  const [verifyErrorBanner, setVerifyErrorBanner] = useState<
    { title?: string; message: string } | null
  >(null);
  const { applyAuthState } = useMyVW();
  const { token, brand, country, buildSearch } = useMyVWQueryParams();
  const myVWSessionDetails = { ...sessionDetails, brand, country };
  const navigate = useNavigate();

  useEffect(() => {
    const isAccountLocked = sessionStorage.getItem("isAccountLocked");
    if (isAccountLocked === "true") {
      setAccountLocked(true);
    }
  }, [accountLocked]);

  //Not allow login button to enable if whitespace is enterned intially
  const hasNonWhitespace = (s) => /\S/.test(s || "");

  const onSubmit = async (payload) => {
    sessionStorage.setItem("isAccountLocked", false);
    Logger.info(
      "Attempt to Login",
      "Location ==> /login",
      sessionDetails,
      "",
      "",
      payload.username
    );
    setSubmitPending(true);
    setAccountLocked(false);
    setVerifyErrorBanner(null);
    const body = {
      ...payload,
      sessionDetails,
      forceFullMfa: true,
      shouldEnrollInPaperless: true,
    };
    const { data, error } = await login(body);
    if (data?.inMaintenance) {
      navigate(`/login`);
    }
    if (data?.isSuccess) {
      
      if (!data?.loginAuthenticatorCode) {
        Logger.error("No loginAuthenticatorCode returned from CustomerLogin API", "Location ==> /login", JSON.stringify(data), sessionDetails, "", "", payload.username);
        setSubmitPending(false);
        setError("username", { type: "string" });
        setError("password", { type: "string" });
        return;
      }

      applyAuthState({
        partyId: data?.partyId,
        email: data?.email,
        loginAuthenticatorCode: data?.loginAuthenticatorCode,
        username: payload.username,
      });

      const shouldGoToConsent = data?.EnrollInPaperless;

      setSubmitPending(false);

      if (shouldGoToConsent) {
        onLoginSuccess('consent');
      } else {
        navigate('/myVW/mfa' + buildSearch({
          loginAuthenticatorCode: data.loginAuthenticatorCode,
          isLinked: 'false',
          username: payload.username,
        }), { replace: true });
      }
      return;
    }
    if (data?.errors?.ErrorCode === "badRequest_accountLocked") {
      Logger.info(
        "Account Locked on Login",
        "Location ==> /login",
        sessionDetails,
        "",
        "",
        payload.username
      );
      setSubmitPending(false);
      setAccountLocked(true);
      return;
    }
    if (data?.errors?.ErrorCode === "badRequest_noEmailAddress") {
      Logger.info(
        "CustomerLogin API badRequest_noEmailAddress",
        "Location ==> /login",
        sessionDetails,
        "",
        "",
        payload.username
      );
      setSubmitPending(false);
      setNoEmailAdressError(true);
      return;
    }
    if (data?.errors) {
      Logger.error(
        "CustomerLogin API returns error",
        "Location ==> /login",
        data?.errors,
        sessionDetails,
        "",
        "",
        payload.username
      );
    }
    if (data?.loginAttemptCount) {
      Logger.info(
        `Unsuccessful Login Attempt Count - ${data.loginAttemptCount}`,
        "Location ==> /login",
        sessionDetails,
        "",
        "",
        payload.username
      );
      setSubmitPending(false);
      setBadCount(data.loginAttemptCount);
    }
    if (data?.error) {
      Logger.error(
        "CustomerLogin API Error",
        "Location ==> /login",
        error,
        sessionDetails,
        "",
        "",
        payload.username
      );
    }
    if (error) {
      Logger.error(
        "CustomerLogin API Error",
        "Location ==> /login",
        error,
        sessionDetails,
        "",
        "",
        payload.username
      );
    }
    setSubmitPending(false);
    setError("username", { type: "string" });
    setError("password", { type: "string" });
  };
  return (
    <>
      <Loader isLoading={submitPending} />
      {badCount >= 2 && !accountLocked && (
        <div className="banner-notification">
          <BannerNotification
            title={`${i18n.t(rk.TITLE_LOCKOUT_WARNING1)} ${5 - badCount}
             ${badCount === 4 ? i18n.t(rk.TITLE_LOCKOUT_WARNING3) : i18n.t(rk.TITLE_LOCKOUT_WARNING2)}`}
            notificationStyle="warning"
          >
            {i18n.t(rk.TEXT_LOCKOUT_WARNING)}
          </BannerNotification>
        </div>
      )}
      {noEmailAdressError === true && (
        <div className="banner-notification">
          <BannerNotification notificationStyle="error">
            {i18n.t(rk.ERROR_API_NO_EMAIL_ADRESS_VW)}
          </BannerNotification>
        </div>
      )}
      {verifyErrorBanner && (
        <div className="banner-notification">
          <BannerNotification notificationStyle="error" title={verifyErrorBanner.title}>
            {verifyErrorBanner.message}
          </BannerNotification>
        </div>
      )}
      {accountLocked && (
        <div className="banner-notification">
          <BannerNotification notificationStyle="error">
            {i18n.t(rk.TEXT_LOCKOUT_ERROR)}
          </BannerNotification>
        </div>
      )}
      <form data-testid="form-container">
        <FormField
          id="username"
          label={i18n.t(rk.LABEL_USERNAME)}
          type="text"
          testid="username-field"
          onChange={(e) => {
            setValue("username", e.target.value);
            clearErrors("username");
            setVerifyErrorBanner(null);
            setAccountLocked(false);
            sessionStorage.setItem("isAccountLocked", false);
          }}
          onCopy={(e) => {
            e.preventDefault();
            return false;
          }}
          onPaste={(e) => {
            e.preventDefault();
            return false;
          }}
          onBlur={() => {
            if (errors.username) {
              Logger.info(
                `User entered invalid username on login screen ==> ${getValues().username}`,
                "Location ==> /Login",
                sessionDetails,
                "",
                "",
                ""
              );
            }
          }}
          autoCompleteOff
          value={getValues().username}
          fieldRef={register}
          fieldErrors={errors.username && i18n.t(rk.ERROR_API_INVALID_USERNAME)}
        />
        <FormField
          id="password"
          label={i18n.t(rk.LABEL_PASSWORD)}
          type="password"
          testid="password-field"
          onChange={(e) => {
            setValue("password", e.target.value);
            clearErrors("password");
            setVerifyErrorBanner(null);
            setAccountLocked(false);
            sessionStorage.setItem("isAccountLocked", false);
          }}
          onCopy={(e) => {
            e.preventDefault();
            return false;
          }}
          onBlur={() => {
            if (errors.password) {
              Logger.info(
                "User entered invalid password",
                "Location ==> /Login",
                sessionDetails,
                "",
                "",
                ""
              );
            }
          }}
          autoCompleteOff
          value={getValues().password}
          fieldRef={register}
          fieldErrors={errors.password && i18n.t(rk.ERROR_API_INVALID_PASSWORD)}
        />
        <div className="btn-container">
          <Button
            type="submit"
            value={i18n.t(rk.BUTTON_LOGIN)}
            disabled={
              !getValues().username || !hasNonWhitespace(getValues().password)
            }
            onClick={handleSubmit(onSubmit)}
            testid="secure-login-btn"
            customClass="c-btn--full"
          />
        </div>
      </form>
      <style jsx>{`
        .btn-container {
          display: flex;
          justify-content: center;
          padding-bottom: 4%;
          padding-top: 5%;
        }
        .banner-notification {
          margin: -15px 0 50px;
        }
      `}</style>
    </>
  );
};

export default LoginForm;

LoginForm.propTypes = {
  setStep: func,
  setEmail: func,
  setPartyId: func,
  setUserAuthInfo: func,
};

LoginForm.defaultProps = {
  setStep: () => {},
  setEmail: () => {},
  setPartyId: () => {},
  setUserAuthInfo: () => {},
};